"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _radium = _interopRequireDefault(require("radium"));

var _ContentTopCss = _interopRequireDefault(require("./ContentTop.css.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentTop = function ContentTop(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _ContentTopCss.default.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _ContentTopCss.default.contentTop
  }, text));
};

var _default = (0, _radium.default)(ContentTop);

exports.default = _default;

//# sourceMappingURL=ContentTop.jsx.map